import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/out-in-stock-record/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/out-in-stock-record/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/out-in-stock-record/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/out-in-stock-record/select/page',
        method: 'get',
        params
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/out-in-stock-record/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}

